export function formatRon(amount, options = {}) {
  const n = Number(amount) || 0
  return new Intl.NumberFormat("ro-RO", {
    style: "currency",
    currency: "RON",
    minimumFractionDigits: options.minimumFractionDigits ?? 2,
    maximumFractionDigits: options.maximumFractionDigits ?? 2,
  }).format(n)
}

export function formatDate(iso) {
  if (!iso) return "—"
  return new Date(iso).toLocaleDateString("ro-RO")
}

export function formatDateTime(iso) {
  if (!iso) return "—"
  return new Date(iso).toLocaleString("ro-RO")
}
